export default "__VITE_ASSET__DETjCkpv__"